import { DocumentsProvider } from '@/components/DocumentsProvider';
import { IdleWarningModal } from '@/components/IdleWarningModal';
import { MessageProvider } from '@/components/Message';
import { ErrorBoundary } from '@/config/bugsnagConfig';
import { leaveBreadcrumb } from '@/config/bugsnagHelpers';
import { frontendConfig } from '@/config/frontendConfig';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { IdleDetectionProvider } from '@/features/session';
import { store } from '@/store';
import '@/styles/globals.css';
import { DynamicThemeProvider } from '@/theme/ThemeProvider';
import type { AppProps } from 'next/app';
import Router from 'next/router';
import { Provider } from 'react-redux';
import SuperTokens from 'supertokens-web-js';
import '../config/bugsnagPerformance';
let previousPath: string | null = null;

if (typeof window !== 'undefined') {
  SuperTokens.init(frontendConfig());
  previousPath = window.location.pathname + window.location.search;
  Router.events.on('routeChangeComplete', (url) => {
    leaveBreadcrumb('Route change', {
      from: previousPath,
      to: url,
    });
    previousPath = url;
  });
}

const App = ({ Component, pageProps }: AppProps) => {
  if (!ErrorBoundary) {
    return (
      <DynamicThemeProvider>
        <MessageProvider>
          <Provider store={store}>
            <AuthProvider>
              <IdleDetectionProvider>
                <DocumentsProvider>
                  <Component {...pageProps} />
                </DocumentsProvider>
                <IdleWarningModal />
              </IdleDetectionProvider>
            </AuthProvider>
          </Provider>
        </MessageProvider>
      </DynamicThemeProvider>
    );
  }
  return (
    <ErrorBoundary>
      <DynamicThemeProvider>
        <MessageProvider>
          <Provider store={store}>
            <AuthProvider>
              <IdleDetectionProvider>
                <DocumentsProvider>
                  <Component {...pageProps} />
                </DocumentsProvider>
                <IdleWarningModal />
              </IdleDetectionProvider>
            </AuthProvider>
          </Provider>
        </MessageProvider>
      </DynamicThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
